import { ElementRef, inject, Injectable } from '@angular/core';
import { Dialog } from '@angular/cdk/dialog';
import { ConnectedPosition, Overlay } from '@angular/cdk/overlay';
import { HelpDialogComponent } from '../dialogs/overig/help-dialog/help-dialog.component';
import { FeedbackMenuDialogComponent } from '../dialogs/overig/feedback-menu-dialog/feedback-menu-dialog.component';
import { FavorietenDialogComponent } from '../dialogs/favorieten/favorieten-dialog/favorieten-dialog.component';

/** Positionering van de Favorieten-pop-out t.o.v. een header-icoon (uitlijnen onder het icoon). */
export const HEADER_FAVORIETEN_POSITIONS: ConnectedPosition[] = [
	{ originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
	{ originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' },
];

/**
 * Opent de Help-, Feedback- en Favorieten-pop-outs/-dialogen. Gedeeld door de oude header
 * (header.component.ts) en de verticale hoofdnavigatie, zodat beide dezelfde implementatie
 * gebruiken in plaats van hem te dupliceren.
 */
@Injectable({
	providedIn: 'root',
})
export class HeaderActiesService {
	private readonly dialog = inject(Dialog);
	private readonly overlay = inject(Overlay);

	openHelp() {
		this.dialog.open(HelpDialogComponent);
	}

	openFeedback(anker: ElementRef) {
		this.dialog.open(FeedbackMenuDialogComponent, {
			backdropClass: 'cdk-overlay-transparent-backdrop',
			positionStrategy: this.overlay
				.position()
				.flexibleConnectedTo(anker)
				.withViewportMargin(16)
				.withPositions([
					{ originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetY: 8 },
					{ originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top', offsetY: 8 },
				]),
		});
	}

	openFavorieten(anker: ElementRef, positions: ConnectedPosition[] = HEADER_FAVORIETEN_POSITIONS, backdropClass?: string) {
		return this.dialog.open<void>(FavorietenDialogComponent, {
			...(backdropClass ? { backdropClass } : {}),
			positionStrategy: this.overlay.position().flexibleConnectedTo(anker).withPositions(positions),
		});
	}
}
